import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { ComposerOfferOrOrder, IActionTypes } from '../../../../models/action.model';
import { DateTimeHelper, TimePeriodType } from '../../../../helper/date-time.helper';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import {
  IContact, LeadComposerChangesModel,
} from '../../../../models/leads/leads.model';
import { AppointmentsHelper } from '../../../../helper/appointments.helper';
import { UserTokenService } from '../../../../services/user-service/user-token.service';
import { ConvertHelper } from "../../../../helper/convert.helper";
import { ActionHelper } from '../../../../helper/action.helper';
import { CurrencyHelper } from '../../../../helper/app-currency';

@Component({
  selector: 'fi-offer-editor',
  templateUrl: './composer-offer-order-editor.component.html',
  styleUrls: ['./composer-offer-order-editor.component.scss'],
  standalone: false,
})
export class ComposerOfferOrderEditorComponent implements OnInit, OnDestroy {
  @Input() inputData: { isOrder: boolean, leadId: number, data?: LeadComposerChangesModel };
  @Input() showSaveAndPlaceButton: boolean;

  @Output() edited = new EventEmitter<ComposerOfferOrOrder>();
  @Output() editedWithPlaceOrder = new EventEmitter<ComposerOfferOrOrder>();

  contactName = '';
  leadId: number;
  selectedDateOptionId: number;

  readonly dateOptionTypes = DateTimeHelper.datePeriodTypes;

  searchedText = '';
  note = '';
  selectedDate: Date;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('NEW-EMAIL', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('NEW-EMAIL', true);
  submitting: boolean;
  contactToDisplay: IContact;
  contact: IContact;
  appointmentExists = false;
  leadTypeId: number;
  extendedProperties = {
    CURRENCY: '',
    AMOUNT: null,
    NAME: null,
  };
  currencies = CurrencyHelper.FINSTRAL_CURRENCIES;
  currencyId: number;
  offerAmount: string;
  inValidTextNumber = false;
  inValidNote = false;
  inValidOfferAmount = false;
  isEdit = false;
  titleKey = '';
  private data: LeadComposerChangesModel;

  constructor(
    private userTokenService: UserTokenService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService
  ) {

  }

  private initialize(): void {
    this.leadId = this.inputData.leadId;
    this.data = this.inputData.data;
    this.extendedProperties.CURRENCY = this.userTokenService.getCurrency() ?? CurrencyHelper.DEFAULT_CURRENCY;
    this.currencyId = CurrencyHelper.getCurrencyId(this.extendedProperties.CURRENCY);
    this.isEdit = !!this.inputData.data;

    if ( !this.inputData.data?.IsOrder && this.inputData.data?.IsMain === false ) {
      this.titleKey = 'REQUEST_DETAIL_HEADER_MENU_ALTERNATIVES_EDIT';
    } else if ( this.inputData.isOrder ) {
      this.titleKey = this.isEdit ? 'REQUEST_DETAIL_HEADER_MENU_ORDER_EDIT' : 'REQUEST_DETAIL_HEADER_MENU_ADD_ORDER_MANUALLY';
    } else {
      this.titleKey = this.isEdit ? 'REQUEST_DETAIL_HEADER_MENU_OFFER_EDIT' : 'REQUEST_DETAIL_HEADER_MENU_ADD_OFFER_MANUALLY';
    }

    if ( this.isEdit ) {
      this.extendedProperties = {
        CURRENCY: this.inputData.data.CurrencyCode,
        AMOUNT: this.inputData.data.Amount,
        NAME: this.inputData.data.Name
      };

      this.currencyId = this.currencies.find(item => item.Description === this.inputData.data.CurrencyCode)?.Id;
    }
  }

  onDateSelect( date: Date ): void {
    this.selectedDate = date;
    this.selectedDateOptionId = undefined;
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  onDateOptionSelected( type: TimePeriodType ): void {
    this.selectedDateOptionId = type.Id;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(type);
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  async ngOnInit(): Promise<void> {
    this.initialize();
    const userId = await this.userTokenService.getId();
    AppointmentsHelper.getDbAppointments(this.actionDataService, userId);
  }

  setExtendedProperties( currency: string ): void {
    this.currencies.forEach(el => {
      if ( el.Id.toString() === currency ) {
        this.extendedProperties.CURRENCY = el.Description;
      }
    })
  }

  getCurrencyIdByName(): void {
    this.currencies.forEach(el => {
      if ( el.Description === this.extendedProperties.CURRENCY ) {
        this.currencyId = el.Id;
      }
    })
  }

  closeDialog(): void {
    ///////////////////////////      this.clearClassAndCloseDialog(this.dialogRef);
  }


  get numberIsValid(): boolean {
    const value = this.extendedProperties.NAME;

    if ( !value ) {
      this.inValidTextNumber = true;
      return false;
    }

    const str = value.toString().trim(); // ensure it's a string and trim spaces
    this.inValidTextNumber = str.length < 0 || str.length > 50;

    return !this.inValidTextNumber;
  }

  sumIsValid(): boolean {
    if ( !this.extendedProperties.AMOUNT ) {
      this.inValidOfferAmount = true;
      return false;
    }
    this.inValidOfferAmount = !(this.extendedProperties.AMOUNT + '').match(/^(\d+|\d*[.,]\d+)$/g);
    return !this.inValidOfferAmount;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  delete(): void {
    this.submitting = false;

    this.actionDataService.deleteComposerOfferOrder(this.leadId, this.data.Id)
      .subscribe(( { success, data } ) => {
        if ( success ) {
          // this.clearClassAndCloseDialog(this.dialogRef, 'Added Composer ' + (this.dialogData.isOrder ? 'Order': 'Offer'));
          ///////////////////////////               this.dialogRef.close(this.extendedProperties);
          this.edited.emit(this.extendedProperties as any);
        }

        this.submitting = false;
      });
  }

  submit( placeOrder?: boolean ): void {
    let sumIsValid = this.sumIsValid();
    if ( this.numberIsValid && sumIsValid ) {
      this.submitting = true;
      const offerExtProp = <ComposerOfferOrOrder>{
        Amount: !this.offerAmount ? +`${this.extendedProperties.AMOUNT}`.replace(',', '.') : ConvertHelper.currencyToNumber(this.offerAmount),
        CurrencyCode: this.extendedProperties.CURRENCY,
        Name: this.extendedProperties.NAME,
        Commission: '',
        OfferId: this.data?.Id,
        IsOrder: this.inputData.isOrder,
        IsSelected: true
      }

      this.actionDataService.submitComposerOfferOrder(this.leadId, offerExtProp)
        .subscribe(( { success, data } ) => {
          if ( success ) {
            // this.clearClassAndCloseDialog(this.dialogRef, 'Added Composer ' + (this.dialogData.isOrder ? 'Order': 'Offer'));
            ///////////////////////////        this.dialogRef.close(offerExtProp);
            if ( placeOrder ) {
              this.placeOrder(offerExtProp);
            } else {
              this.edited.emit(offerExtProp);
              this.submitting = false;
            }
          } else {
            this.submitting = false;
          }

        });
    }
  }

  ngOnDestroy(): void {
    ActionHelper.initializeOrResetUnsavedChanges();
  }

  private placeOrder( offerExtProp: ComposerOfferOrOrder ) {
    const placeInOrder = {
      Comment: '',
      CustomerCode: '',
      CustomerCodeComposer: '',
    };
    this.actionDataService.placeOrder(this.leadId, placeInOrder, false)
      .subscribe(( { success, data } ) => {
        if ( success ) {
          this.editedWithPlaceOrder.emit(offerExtProp);
        }
        this.submitting = false;
      });
  }
}
